import * as ng from 'angular';

export const NgPrint: ng.IDirectiveFactory = () => {
    let printSection = document.getElementById('printSection');

    // if there is no printing section, create one
    if (!printSection) {
        printSection = document.createElement('div');
        printSection.id = 'printSection';
        document.body.appendChild(printSection);
    }

    function link(scope: any, element: JQLite, attrs: any) {
        element.on('click', () => {
            var elemToPrint = document.getElementById(attrs.printElementId);
            if (elemToPrint) {
                printElement(elemToPrint);
                window.print();
                printSection.innerHTML = '';
            }
        });

        window.onafterprint = () => {
            // clean the print section before adding new content
            printSection.innerHTML = '';
        };
    }

    function printElement(elem: any) {
        // clones the element you want to print
        let domClone = elem.cloneNode(true);
        printSection.appendChild(domClone);
    }

    return {
        link: link,
        restrict: 'A'
    };
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/ng-print/ng-print.directive.ts